import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './IssuerZoneNav.module.css';

export default function IssuerZoneNav() {
  const { t, i18n } = useTranslation('common');
  const location = useLocation();
  const activeLanguage = i18n.resolvedLanguage || i18n.language || 'en-US';

  const languageOptions = [
    { code: 'en-US', label: 'EN' },
    { code: 'pt-BR', label: 'PT' }
  ];

  const isAuth = location.pathname === '/issuer-auth';
  const isDashboard = location.pathname === '/issuer-dashboard';

  const handleLanguageChange = (nextLanguage) => {
    if (nextLanguage === activeLanguage) {
      return;
    }

    if (typeof window !== 'undefined') {
      window.localStorage.setItem('locale', nextLanguage);
    }

    if (typeof document !== 'undefined') {
      document.documentElement.lang = nextLanguage;
    }

    i18n.changeLanguage(nextLanguage).catch(() => {});
  };

  return (
    <header className={styles.navWrap}>
      <div className={styles.navShell}>
        <div className={styles.brandBlock}>
          <p className={styles.brandEyebrow}>{t('issuerNav.productZone', 'Issuer Product Zone')}</p>
          <h1>{t('issuerNav.title', 'Innova Issuer Suite')}</h1>
        </div>

        <div className={styles.actions}>
          <nav className={styles.navLinks} aria-label={t('issuerNav.aria', 'Issuer navigation')}>
            <Link className={`${styles.navLink} ${isAuth ? styles.navLinkActive : ''}`} to="/issuer-auth">
              {t('issuerNav.workspace', 'Workspace')}
            </Link>
            <Link className={`${styles.navLink} ${isDashboard ? styles.navLinkActive : ''}`} to="/issuer-dashboard">
              {t('issuerNav.dashboard', 'Payments Dashboard')}
            </Link>
            <Link className={styles.navLinkGhost} to="/">
              {t('issuerNav.backToMarketplace', 'Back to marketplace')}
            </Link>
          </nav>

          <div className={styles.localePicker} role="group" aria-label={t('issuerNav.languageAria', 'Language selector')}>
            <span className={styles.localeLabel}>{t('issuerNav.language', 'Language')}</span>
            <div className={styles.localeOptions}>
              {languageOptions.map((option) => (
                <button
                  key={option.code}
                  type="button"
                  className={`${styles.localeButton} ${activeLanguage === option.code ? styles.localeButtonActive : ''}`}
                  onClick={() => handleLanguageChange(option.code)}
                  aria-pressed={activeLanguage === option.code}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
